import styled from "styled-components";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";

export const ExpandCell = styled(StyledTableCell)`
    width: 60px;
    padding: 8px !important;
`;

export const AccountCodeCell = styled(StyledTableCell)<{ level: number }>`
    padding-left: ${(props) => 16 + Math.min(props.level, 6) * 24}px !important;
`;

export const AccountCell = styled(StyledTableCell)<{ isHighlighted: boolean }>`
    font-weight: ${(props) =>
        props.isHighlighted ? "bold" : "normal"} !important;
`;
